var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefiAst(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 258,
    viewBox: "0 0 232 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "defi-asteorids"
  }, /*#__PURE__*/React.createElement("g", {
    id: "defi-asteorids__5"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M95.3675 245.991C95.3675 245.991 81.2872 169.198 87.947 144.435L140.502 153.197L156.233 152.992L155.213 165.151L215.485 171.425C215.485 171.425 215.986 193.311 205.431 208.105L184.876 233.722C184.876 233.722 172.317 251.634 160.092 254.475C160.092 254.382 136.606 266.633 95.3675 245.991Z",
    fill: "#5B254E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M87.8559 144.435C87.8559 144.435 87.5591 170.924 111.62 197.338C111.62 197.338 149.037 201.738 181.724 192.605V182.321L192.576 187.723C201.002 183.542 208.705 178.04 215.394 171.425C193.691 165.21 171.415 161.205 148.907 159.471L156.142 153.029C156.142 153.029 129.095 144.342 87.8559 144.435Z",
    fill: "#985965"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M111.614 197.339C111.614 197.339 96.5322 228.468 95.3635 245.991C95.3635 245.991 83.6207 193.459 87.9431 144.435C87.8504 144.435 99.1479 180.41 111.614 197.339Z",
    fill: "#461642"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M181.721 182.321L184.875 194.016L170.127 239.736C170.127 239.736 190.088 204.764 192.573 187.76L181.721 182.321Z",
    fill: "#461642"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.2
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3193 145.827C88.3193 145.827 101.695 176.901 112.436 186.498C123.177 196.095 157.459 187.668 160.371 185.552C163.284 183.435 162.802 178.294 178.514 175.955C194.227 173.616 195.785 169.792 192.539 168.418C189.292 167.045 165.64 167.731 152.97 164.464C140.299 161.197 148.777 156 141.375 153.197C133.973 150.394 99.5241 143.618 88.3193 145.827Z",
    fill: "#D2CCBF"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M91.3462 154.626C91.3462 154.626 107.207 185.737 115.11 189.895C123.013 194.053 162.582 197.821 181.727 192.605C158.919 198.913 135.07 200.523 111.622 197.339C111.622 197.339 98.3214 175.88 91.3462 154.626Z",
    fill: "#B06979"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M108.76 192.494L109.799 201.237L116.459 197.785L108.76 192.494Z",
    fill: "#D27F7C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M189.161 186.015L191.016 194.721L196.358 185.439C196.358 185.439 190.979 184.845 189.161 186.015Z",
    fill: "#B06979"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "defi-asteorids__4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M70.0082 33.9131L37.7295 37.9969L29.6784 41.7094L25.0592 42.8974C25.0592 42.8974 19.4939 50.471 19.4939 65.5439C19.4939 65.5439 31.4593 81.6006 41.4026 85.7029L59.7495 89.1556L70.0082 33.9131Z",
    fill: "#5B254E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M59.7097 89.1365L34.8513 63.9841L41.8265 45.0688H49.5067L69.9128 33.9312C69.9128 33.9312 72.8067 53.6262 69.9128 69.5715C70.0055 69.5529 65.3863 84.2174 59.7097 89.1365Z",
    fill: "#985965"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M34.8563 63.9847C34.8563 63.9847 25.1912 62.1284 19.459 65.5254C19.459 65.5254 23.9669 77.9995 41.3677 85.6844C41.3677 85.6844 54.5946 90.2137 59.7147 89.1371C59.7147 89.1371 41.6274 73.9528 34.8563 63.9847Z",
    fill: "#461642"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M49.51 45.0874H60.1768L55.5577 41.7832L49.51 45.0874Z",
    fill: "#6E3E62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M41.8265 45.0688C41.8265 45.0688 38.9511 54.9442 41.8265 62.4621C44.7019 69.9799 59.7097 89.1366 59.7097 89.1366C59.7097 89.1366 39.3036 72.653 34.8513 63.9842L41.8265 45.0688Z",
    fill: "#B06979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M31.8855 63.4644L36.3191 60.0303V66.3602L31.8855 63.4644Z",
    fill: "#D27F7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M25.0576 42.8788L41.8277 45.0878H49.5078L70.0067 33.9131L37.7279 37.9969L30.2704 41.7836L25.0576 42.8788Z",
    fill: "#6E3E62"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "defi-asteorids__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M90.6375 51.2313C90.6375 51.2313 92.7523 58.5635 98.3918 61.4964H101.378L103.234 64.0766C106.99 64.7298 110.839 64.6162 114.55 63.7425C114.55 63.7425 125.235 59.436 128.055 49.3379L90.6375 51.2313Z",
    fill: "#5B254E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M128.145 49.3567C128.145 49.3567 116.884 54.053 90.709 51.2129C92.7901 49.5379 94.9913 48.0179 97.2947 46.6651L97.5173 46.5352C100.402 44.715 103.651 43.5492 107.034 43.1196C112.293 44.0072 117.487 45.2475 122.58 46.8322C124.52 47.4701 126.386 48.3166 128.145 49.3567Z",
    fill: "#985965"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M128.145 49.3566C128.145 49.3566 116.884 54.053 90.709 51.2129C92.7901 49.5379 94.9913 48.0179 97.2947 46.665C96.6083 47.1105 94.4935 48.5213 95.4396 49.6165C96.3857 50.7117 114.566 51.7698 120.65 50.1548C126.216 48.6327 123.173 47.1291 122.691 46.9064C124.59 47.5281 126.418 48.3494 128.145 49.3566Z",
    fill: "#B06979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M90.6375 51.2319L98.2805 51.8816L101.378 61.4971H98.3918C96.4126 60.4775 94.688 59.0255 93.3457 57.2486C92.0034 55.4717 91.0778 53.4153 90.6375 51.2319Z",
    fill: "#461642"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "defi-asteorids__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M214.931 0.202637C216.582 3.0572 218.541 5.72148 220.774 8.14746C224.151 11.6744 231.719 8.98277 231.719 8.98277C231.719 8.98277 229.4 6.99659 229.53 1.92898L214.931 0.202637Z",
    fill: "#5B254E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M214.931 0.202637C214.931 0.202637 224.93 0.202651 229.53 1.92898C229.53 1.92898 228.287 2.6158 228.603 3.78525C229.421 5.64078 230.468 7.38677 231.719 8.98277C231.719 8.98277 226.506 9.83667 214.931 0.202637Z",
    fill: "#985965"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "defi-asteorids__1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M15.7673 121.195C15.7673 121.195 12.6136 120.267 4.17291 124.499C2.01123 127.108 0.829937 130.391 0.833749 133.78L2.94848 137.975C2.94848 137.975 1.70555 147.127 3.63486 152.658C3.63486 152.658 11.0553 159.304 19.9783 158.042C28.9013 156.779 40.5514 140.667 40.5514 140.667L15.7673 121.195Z",
    fill: "#5B254E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M40.5511 140.667C40.1676 141.435 39.7273 142.173 39.2339 142.876C36.8594 146.31 31.3683 151.99 22.538 148.63C19.219 147.573 16.3617 145.411 14.4413 142.503C12.5209 139.595 11.6532 136.117 11.9825 132.648C11.9825 130.531 9.1814 125.222 9.1814 125.222C10.0533 122.271 15.062 121.157 15.6927 121.046C24.5303 124.459 32.4783 129.835 38.9372 136.768L40.5511 140.667Z",
    fill: "#985965"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M3.63184 152.714C7.99102 153.864 12.5738 153.864 16.933 152.714C23.1476 150.69 24.1864 149.261 24.1864 149.261C24.1864 149.261 32.5158 152.083 40.6041 140.667C40.6041 140.667 36.8938 151.062 21.2739 158.264C21.2739 158.264 13.8905 161.884 3.63184 152.714Z",
    fill: "#461642"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M40.5511 140.741L39.2339 142.95C36.8594 146.384 31.3683 152.064 22.538 148.704C19.219 147.647 16.3617 145.485 14.4413 142.577C12.5209 139.669 11.6532 136.191 11.9825 132.722C11.9825 130.606 9.1814 125.297 9.1814 125.297C10.0533 122.345 15.062 121.231 15.6927 121.12C15.1918 121.287 11.7414 122.587 10.9994 124.833C10.2573 127.079 11.9825 128.694 13.3738 133.446C14.7652 138.198 19.607 147.405 27.4541 147.349C34.8559 147.423 39.9389 141.483 40.5511 140.741Z",
    fill: "#B06979"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefiAst);
export default __webpack_public_path__ + "static/media/defi_ast.76cc1a5c8738d0c93d70ce4d482b96f2.svg";
export { ForwardRef as ReactComponent };